/**
 * When true, render chat body as plain text + URL linkify instead of Markdown.
 * Keep in sync with MessageCompose storage (GFM strikethrough `~~`, underline `<u>`, etc.).
 *
 * @param {unknown} body
 * @returns {boolean}
 */
export function isChatBodyPlainForDisplay(body) {
    const t = String(body ?? '');
    if (!t.trim()) return true;
    // Inline HTML from the rich composer (underline, or legacy stored HTML) must use Markdown + rehype-raw.
    if (/<\/?[a-z][a-z0-9]*\b/i.test(t)) return false;
    // Strikethrough uses `~` (not in the older class); lists/code/links/blockquote already covered.
    return !/[`*_~#[\]()>!]|(^\s*[-*+]\s)|(^\s*\d+\.\s)/m.test(t);
}
